import { fromBase64 } from '@change-corgi/core/base64';

import type { ComboPageBanditData } from '../types';

export function getComboPageBanditData(comboBanditData: string | undefined): ComboPageBanditData | undefined {
	if (!comboBanditData) return undefined;

	try {
		const decodedBanditData = fromBase64(comboBanditData);

		const parsedComboBanditData = JSON.parse(decodedBanditData) as NonNullable<ComboPageBanditData['comboBanditData']>;
		if (!parsedComboBanditData.amountId) return undefined;

		return { comboBanditData: parsedComboBanditData };
	} catch (e) {
		return undefined;
	}
}
